import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/browser';
import clevertap from 'clevertap-web-sdk';
import { datadogRum } from '@datadog/browser-rum';
import 'animate.css';

import 'react-datepicker/dist/react-datepicker.css';
import './tailwind/tailwind.css';

import { filterNewMessageContents } from 'src/helpers/sentryHelper';

import { App } from './App';
import * as serviceWorker from './serviceWorker';
import { ErrorBoundary } from './components/ErrorBoundary.tsx';

Sentry.init({
  dsn: process.env.REACT_APP_DEFAULT_SENTRY_KEY,
  release: process.env.REACT_APP_RELEASE,
  environment: process.env.REACT_APP_DEFAULT_ENV,
  beforeBreadcrumb: (breadcrumb) => {
    // Scrub PHI/PII from GraphQL request data
    if (breadcrumb.category === 'graphql') {
      breadcrumb = filterNewMessageContents(breadcrumb);
    }
    return breadcrumb;
  },
});

if (process.env.REACT_APP_CLEVER_TAP_ACCOUNT_ID) {
  clevertap.privacy.push({ optOut: false });
  clevertap.privacy.push({ useIP: false });
  clevertap.init(process.env.REACT_APP_CLEVER_TAP_ACCOUNT_ID, 'us1');
  clevertap.enablePersonalization = true;
  clevertap.spa = true;
}

if (process.env.REACT_APP_DDRUM_CLIENT_TOKEN) {
  datadogRum.init({
    applicationId: process.env.REACT_APP_DDRUM_APP_ID,
    clientToken: process.env.REACT_APP_DDRUM_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: 'provider-dashboard-web',
    env: process.env.REACT_APP_DEFAULT_ENV,
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '0.1.0',
    sampleRate: 100,
    trackInteractions: true,
  });
}

ReactDOM.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();

// Hot reloading
if (module.hot && process.env.NODE_ENV !== 'production') {
  module.hot.accept();
}
